import { gql } from 'graphql-request'

export const CHECK_NUMBER_HAS_BAN = gql`
  query CheckNumberHasBan($number: String!) {
    checkNumberHasBan(number: $number)
  }
`
